import React from "react";
import styled from "styled-components";

import { colorFromTheme, hsl } from "@examspark/common-ui/dist/utils/color";
import { RubricDocument as RubricType } from "@examspark/types";

import UnitContent from "../common/UnitContent";

const ScoreCell = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 25rem;
  min-width: 25rem;
  border-left: solid 1px #ddd;
  text-align: center;
  padding: 1rem;
`;

const SectionHeader = styled.div`
  /* display: flex; */
  background-color: ${colorFromTheme("surface5")};
  padding: 1rem;
`;

const StyledRow = styled.div`
  display: flex;
  border-top: solid 1px #ddd;
  width: fit-content;

  &:first-child {
    border-top: none;
  }
`;
const DataCell = styled.div`
  width: 25rem;
  box-sizing: border-box;
  min-width: 25rem;
  min-height: 25rem;
  border-left: solid 1px #ddd;
  display: flex;
  flex-direction: column;
  line-height: 1.4em;

  &:first-child {
    border-left: none;
  }
`;
const CategoryCell = styled.div`
  width: 20rem;
  min-width: 20rem;
  position: sticky;
  left: 0;
  background-color: ${(props) => hsl(props.theme.colors?.surface3.color, 0.7)};
  backdrop-filter: blur(4px);
  padding: 1rem;

  .cke_editable {
    flex: 1;
    padding: 1rem;
    height: 100%;
    box-sizing: border-box;
  }
`;

const StyledRubric = styled.div`
  /* margin: 1rem; */
  border: solid 1px #ddd;
  position: relative;
  width: fit-content;
`;

const Header = styled.div`
  display: flex;
  border-bottom: solid 3px #ddd;
  width: 100%;
  background-color: ${colorFromTheme("surface0")};
`;

const GutterCell = styled.div`
  width: 20rem;
  min-width: 20rem;
  position: sticky;
  left: 0;
  background-color: ${(props) => hsl(props.theme.colors?.surface3.color, 0.7)};
  backdrop-filter: blur(4px);
  padding: 1rem;
`;
const InnerSection = styled.div``;

const Scrollable = styled.div`
  overflow-x: auto;
  // this prevent the rubric width from being used to calculate the width of the
  // flex container itself, which would make it way too wide
  contain: inline-size;
`;
type RubricEditorProps = {
  data: RubricType;
};
const Rubric = ({ data }: RubricEditorProps) => {
  if (!data.headers) return null;
  if (!data.sections) return null;

  return (
    <Scrollable>
      <StyledRubric>
        <Header>
          <GutterCell></GutterCell>
          {data.headers.map((header, columnIndex) => (
            <ScoreCell key={columnIndex}>
              <UnitContent content={header.value} />
            </ScoreCell>
          ))}
        </Header>
        {data.sections.map((section, sectionIndex) => (
          <InnerSection key={sectionIndex}>
            <SectionHeader>
              <UnitContent content={section.sectionLabel} />
            </SectionHeader>
            {section.rows.map((row, rowIndex) => (
              <StyledRow key={rowIndex}>
                <CategoryCell>
                  <UnitContent content={row.criteriaLabel} />
                </CategoryCell>
                {row.cellData.map((cell, cellIndex) => (
                  <DataCell key={cellIndex}>
                    <UnitContent content={cell.value} />
                  </DataCell>
                ))}
              </StyledRow>
            ))}
          </InnerSection>
        ))}
      </StyledRubric>
    </Scrollable>
  );
};

export default Rubric;
